import { useEffect, useRef } from "react";
import { pushToDataLayer } from "analytics";

export const useScrollDepth = () => {
  const depthsTracked = useRef<Set<number>>(new Set());

  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollDepth = Math.round((window.scrollY / scrollHeight) * 100);

      [25, 50, 75, 90, 100].forEach((depth) => {
        if (scrollDepth >= depth && !depthsTracked.current.has(depth)) {
          depthsTracked.current.add(depth);
          pushToDataLayer("gh_scroll_depth", { depth_percentage: depth });
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
};
